<template>
  <ChainList :distributor_id="distributor_id" :subdistributor_id="subdistributor_id"/>
</template>

<script>
import ChainList from '@/components/ChainList';

export default {
  name: 'ChainsTab',
  props: ['distributor_id', 'subdistributor_id'],

  components: {
    ChainList,
  },
};
</script>
